<template>
	<v-row justify="center">
		<v-dialog 
			v-model="categoryDialog" 
			persistent 
			max-width="600"
			:retain-focus="false"
		>
			<!-- Boton de activacion Modal -->
				<template v-slot:activator="{ on }">
					<v-col align="right" justify="center" class="my-3">
						<v-btn class="mt-2" fab dark color="secondary" v-on="on">
							<v-icon dark>mdi-plus</v-icon>
						</v-btn>
					</v-col>
				</template>
				<v-card>
					<v-card-title class="headline">{{ categoryDialogEditMode ? 'EDITAR' : 'CREAR'}} CATEGORIA</v-card-title>
						<v-card-text>
							<v-form v-model="formValidity">
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field
												color="admin_accent"
												v-model="categoryForEdit.name"
												label="Titulo"
												prepend-inner-icon="mdi-view-agenda"
												dense
												filled />
										<v-text-field
												color="admin_accent"
												v-model="categoryForEdit.subtitle"
												label="Subtitulo"
												prepend-inner-icon="mdi-view-agenda-outline"
												dense
												filled />

										<v-switch
												inset class="ma-2"
												color="success"
												v-model="categoryForEdit.visible"
												:label="`Visible: ${categoryForEdit.visible ? 'SI' : 'NO'}`" />
										<v-switch
												inset class="ma-2"
												color="success"
												v-model="categoryForEdit.hidetitle"
												:label="`Esconder título: ${categoryForEdit.hidetitle ? 'SI' : 'NO'}`" />
										<v-switch
												inset class="ma-2"
												color="success"
												v-model="categoryForEdit.overlay"
												:label="`Overlay: ${categoryForEdit.overlay ? 'NO' : 'SI'}`" />				
									</v-col>
									<v-col cols="12" md="6">

										<v-card>
											<image-uploader
												ref="imager"
												:maxWidth="600"
												:quality="0.7"
												:preview="true"
												:className="['fileinput', { 'fileinput--loaded': hasImage }]"
												:capture="false"
												:debug="1"
												doNotResize="gif"
												:autoRotate="true"
												outputFormat="verbose"
												@input="setImage"
											>
											
												<label for="fileInput" slot="upload-label">
													<v-img 
															v-if="showImage"
															:src="(photoExist) ? categoryForEdit.photo_url : noImage"
															aspect-ratio="1.778"
														/>
													<figure>
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width="32"
															height="32"
															viewBox="0 0 32 32"
														>
															<path
																class="path1"
																d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
															></path>
														</svg>
													</figure>
													<span class="upload-caption">{{
														hasImage ? "Click Reemplazar" : "Click para subir"
													}}</span>
												</label>
											</image-uploader>
										</v-card>	

									</v-col>
								</v-row>
							</v-form>
						
						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn :loading="saving" class="white--text" color="admin_accent" @click="update" v-if="categoryDialogEditMode">ACTUALIZAR CATEGORIA</v-btn>
							<v-btn :loading="saving" class="white--text" color="admin_accent" @click="add" v-else>CREAR CATEGORIA</v-btn>
							<v-btn outlined color="secondary" @click="close">CANCELAR</v-btn>
						</v-card-actions>
				</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
	import { mapState, mapActions, mapGetters} from 'vuex';
	import { db, storage } from '@/main';
	export default {
		data: () => ({
			hasImage: false,
			saving: false,
			noImage: '/static/images/not-logo.jpg',
			photo: {
				dataUrl: '/static/images/not-logo.jpg'
			},
			uploaded: false,
			formValidity: false,
			textRules: [v => !!v || "Este dato es requerido"],
		}),
		methods:{
			setImage: function(output) {
				this.hasImage = true;
				this.photo = output;
				this.uploaded = true;
				this.categoryForEdit.photo_url = null
			},
			async add(){
				this.saving = true
				this.categoryForEdit.id = Math.floor(Date.now() / 1000).toString();
				const business_id = this.$route.params.business_id;
				let next = 0;
				await db.collection('bussiness').doc(business_id).collection('categories').get()
					.then( (snap) => {
						next = snap.size+1
					})
				this.categoryForEdit.order = next	

				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`categories/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.categoryForEdit.photo_url = await refPhoto.getDownloadURL()
					this.categoryForEdit.photo_name = fileNamePhoto
					this.hasImage = false;
					this.photo = null;
					this.uploaded = false;
				}

				db.collection('bussiness').doc(business_id).collection('categories').doc(this.categoryForEdit.id)
					.set( this.categoryForEdit )
					.then( docRef => {
						this.close();
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,
							color: 'success',
							message: 'Categoria creada satisfactoriamente',
							timeout: 2000
						});	
						this.saving = false
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
						this.saving = false
					})	
			
			},
			async update(){
				this.saving = true
				const business_id = this.$route.params.business_id;
				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`categories/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.categoryForEdit.photo_url = await refPhoto.getDownloadURL()
					this.categoryForEdit.photo_name = fileNamePhoto
					this.hasImage = false;
					this.photo = null;
					this.uploaded = false;
				}

				db.collection('bussiness').doc(business_id).collection('categories').doc(this.categoryForEdit.id)
					.update( this.categoryForEdit )
					.then( docRef => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,color: 'success',timeout: 1000,
							message: 'categoria actualizada satisfactoriamente',
						});	
						this.close();
						this.saving = false
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
						this.saving = false
					})
			},
			close(){
				this.$store.dispatch('categoryModule/toggleCategoryDialog', {
					editMode: false,
					category: {
						id: '',
						name: '',
						order: 1,
						photo_name: '',
						photo_url: '',
						subtitle: '',
						visible: true
					}
				});	
				this.hasImage = false;
				this.photo = null;
				this.uploaded = false;
				this.$refs.imager['imagePreview'] = null;
				this.categoryForEdit.photo_url = null;
			},
			uploadPhoto(event,type) {
				const extensionFile = event.target.files[0].type;
				if(extensionFile === 'image/jpeg' || extensionFile === 'image/png'){
					this.file = event.target.files[0]
					this.error = null
				}else{
					this.error = 'Archivo no válido'
					this.file = null
					return 
				}
				const reader = new FileReader();
				reader.readAsDataURL(this.file);
				reader.onload = (e) => {
					this.photo = e.target.result
					this.uploaded = true;
				}
					
			}, //.uploadPhoto

		},
		computed: {
			...mapState('businessModule',['business']),
			...mapState('categoryModule',['category','dialog']),
			...mapGetters('categoryModule',['categoryForEdit', 'categoryDialogEditMode','categoriesDialog']),
			showPhoto() {
				return !this.hasImage && (this.categoryForEdit.photo_url != '');
			},
			categoryDialog: {
				get(){
					return this.categoriesDialog;
				},
				set(){
					this.close()
				}
			},
			photoExist(){
				return (this.categoryForEdit.photo_url != '' && this.categoryForEdit.photo_url !== null )
			},
			showImage(){
				return !this.hasImage && (this.categoryForEdit.photo_url != '')
			},
		}
	}
</script>

<style>
#fileInput {
	display: none;
}

#app > div.v-dialog__content.v-dialog__content--active > div > div > div.v-card__text > form > div > div:nth-child(2) > div > div > img {
	width: 100% !important;
}

	
</style>